// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tEoL","col":"styles_col__2Qi0e"};